import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=1df2feea"
import script from "./the-header.vue?vue&type=script&lang=js"
export * from "./the-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports